import { getClaimDetails, resetClaim } from 'feature/claims/claimSlice';

import ClaimDetails from 'components/ViewClaimDetails/ClaimDetails.component';
import {
	addEventSubscription,
	removeEventSubscription,
	removeSseMessage,
} from 'feature/sseEventManager/sseEventSlice';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AppDispatch, RootState } from 'store/store';
import { SSE_EVENT_TYPE } from 'utils/sse.hook';

const ViewClaimDetails = () => {
	const param = useParams();
	const dispatch = useDispatch<AppDispatch>();

	useEffect(() => {
		dispatch(resetClaim());
		dispatch(getClaimDetails({ claimUuid: param.Uuid as string }));
	}, [dispatch, param.Uuid]);

	/*************  SSE  ********** */
	const { events } = useSelector((store: RootState) => store.sseEvents);

	useEffect(() => {
		dispatch(addEventSubscription(SSE_EVENT_TYPE.CLAIM));
		return () => {
			dispatch(removeEventSubscription(SSE_EVENT_TYPE.CLAIM));
		};
	}, [dispatch]);

	const { claims } = useSelector((store: RootState) => store.claims);

	useEffect(() => {
		events
			.filter(el => el.type === SSE_EVENT_TYPE.CLAIM)
			.forEach(ev => {
				if (claims.find(el => el.claimUUID === ev.key)) {
					dispatch(
						getClaimDetails({ showloader: false, claimUuid: ev.key as string }),
					);
					dispatch(removeSseMessage(ev));
				}
			});
	}, [claims, dispatch, events, param.id]);
	/*************************** */

	return <ClaimDetails />;
};

export default ViewClaimDetails;
